import { isBrowser } from "./browser-utils";

export function getQueryStringParam(paramName: string) {
	const search = isBrowser() ? window.location.search : "";
	const parsedSearch = new URLSearchParams(search);

	return parsedSearch.get(paramName) ?? undefined;
}
